export default {
  dba_report_title: 'Long Content Summarization',
  dba_report_prompt: 'Prompt',
  dba_report_prompt2: 'Merge Prompt',
  dba_report_attachments: 'Attachments',
  dba_report_prompt_placeholder: 'Use fluent English to generate a summary of the following text, including the title, list of participants, agenda, key points, action list, etc.',
  dba_report_upload_button_select: 'Select a File',
  dba_report_upload_message: 'Please upload a txt file within 5MB',
  dba_report_submit: 'Submit',
  dba_report_result_title: 'Results',
  dba_report_prompt_error_none: 'Prompt can not be empty',
  dba_report_file_error_none: 'Please select a file',
  dba_report_copy_text: 'Copy text',
};
